import { createContext, useContext, useState, type ReactNode } from 'react'

export type DhamLang = 'en' | 'hi' | 'hinglish'

interface LangContextValue {
  lang: DhamLang
  setLang: (l: DhamLang) => void
  t: (translations: Record<DhamLang, string>) => string
}

const LangContext = createContext<LangContextValue>({
  lang: 'en',
  setLang: () => {},
  t: (tr) => tr.en,
})

export function DhamLangProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<DhamLang>(() => {
    const saved = localStorage.getItem('dham-lang')
    return (saved as DhamLang) || 'en'
  })

  const changeLang = (l: DhamLang) => {
    setLang(l)
    localStorage.setItem('dham-lang', l)
  }

  const t = (translations: Record<DhamLang, string>) => translations[lang]

  return (
    <LangContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LangContext.Provider>
  )
}

export function useDhamLang() {
  return useContext(LangContext)
}
